import type {
  AssociatedCompany,
  AssociatedCompanyCoverageBenefit,
  BrokerData,
  ConfiguredCoverageBenefit,
  CoveragePlansConfig,
  FeedbackSubmision,
  PlanParametersConfig,
} from '~/config'
import type { UTM } from '~/layers/forms/models/UTM'

export type RemoteConfigurations = Omit<
  SiteApiSchema<'ProductoContratoMasterInitResponseModel'>,
  'userId' | 'userName'
>
export type LocalConfigurations = Partial<{
  brokerContext: BrokerData
  associatedCompanies: AssociatedCompany[]
  associatedComaniesCoverageBenefits: AssociatedCompanyCoverageBenefit[]
  coverageBenefitsConfig: ConfiguredCoverageBenefit[]
  formConfig: Record<string, PropsTypesOf<FormConfig>>
  coveragePlanConfig: CoveragePlansConfig
  planParameters: PlanParametersConfig
  feedbackSubmision: FeedbackSubmision
  UTM?: UTM
}>

export const stores = () => {
  const RemoteConfigurationStore = useState<RemoteConfigurations | null | undefined>(
    'FormConfigStore'
  )
  const LocalConfigurationStore = useState<LocalConfigurations | null | undefined>(
    'FormLocalConfigStore'
  )

  const Debug = useState<boolean | null | undefined>('Debug', () => false)

  return {
    RemoteConfigurationStore,
    LocalConfigurationStore,
    Debug,
  }
}
